import { supabase } from './supabaseClient';

export interface AuditLogEntry {
    action: string;
    details?: any;
}

/**
 * Logs a critical action to the audit_logs table.
 * Automatically fetches the user's IP address.
 */
export const logAction = async (action: string, details?: any) => {
    try {
        // Fetch IP address
        let userIp = 'unknown';
        try {
            const ipResponse = await fetch('https://api.ipify.org?format=json');
            const ipData = await ipResponse.json();
            userIp = ipData.ip;
        } catch (ipError) {
            console.warn('Could not fetch IP for audit log:', ipError);
        }

        // Get current user
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
            console.warn('Cannot log action without authenticated user');
            return;
        }

        // Get user ID from usuarios table
        const { data: userData } = await supabase
            .from('usuarios')
            .select('id_usuario')
            .eq('auth_user_id', user.id)
            .single();

        if (!userData) {
            console.warn('User profile not found for audit log');
            return;
        }

        // Insert log
        const { error } = await supabase
            .from('audit_logs')
            .insert({
                usuario_id: userData.id_usuario,
                accion: action,
                detalles: details,
                ip: userIp
            });

        if (error) {
            console.error('Error saving audit log:', error);
        }
    } catch (error) {
        console.error('Unexpected error in logAction:', error);
    }
};
